<div class="cont-input" *ngIf="!!form">
  <fieldset class="input {{style}}" [class.active]="active || isActivate" [class.not-placeholder]="isEmptyPlaceholder" [ngClass]="addErrorClass(formControlSelector)" >
    <legend>{{label}}</legend>
    <label *ngIf="!isEmptyPlaceholder">{{label}}</label>
    <i *ngIf="!readOnly" aria-hidden="true" class="icon-cancel-small" (click)="resetInput()" ></i>
    <ng-container *ngIf="isDocumentInput; else textInputs">
      <ng-container *ngTemplateOutlet="documentInputs"></ng-container>
    </ng-container>
    <ng-container *ngIf="showInnerErrors; else contentErrors">
      <ng-container *ngTemplateOutlet="errorMessageTemplates"></ng-container>
    </ng-container>
  </fieldset>
</div>

<ng-template #contentErrors>
  <ng-content select="[errors]"></ng-content>
</ng-template>

<ng-template #errorMessageTemplates>
  <ng-container *ngIf="isDocumentInput; else formInputErrors">
    <ng-container *ngTemplateOutlet="documentInputError"></ng-container>
  </ng-container>
</ng-template>

<ng-template #formInputErrors>
  <ng-container *ngIf="errorWithPattern; else errorWithEmailPatternTemplate">
    <span class="only-error" [ngClass]="addErrorClass(formControlSelector)">
      {{'BOOKING_MODULE.PAX.ERRORS.DIACRITICS_FIELD' | transloco}}
    </span>
  </ng-container>
</ng-template>

<ng-template #errorWithEmailPatternTemplate>
  <ng-container *ngIf="errorWithEmailPattern; else errorGeneral">
    <span class="only-error" [ngClass]="addErrorClass(formControlSelector)">
      {{'BOOKING_MODULE.PAX.ERRORS.EMAIL_FIELD' | transloco}}
    </span>
  </ng-container>
</ng-template>

<ng-template #documentInputError>
  <ng-container *ngIf="showGeneralError; else customOrInternationalError">
    <ng-container *ngTemplateOutlet="errorGeneral"></ng-container>
  </ng-container>
</ng-template>

<ng-template #customOrInternationalError>
  <ng-container *ngIf="hasInternationalDocumentError; else customOrGeneralNotEmpty">
    <ng-container *ngTemplateOutlet="internationalMandatoryError"></ng-container>
  </ng-container>
</ng-template>

<ng-template #customOrGeneralNotEmpty>
  <ng-container *ngIf="!!hasCustomDocumentErrorMessage; else generalNotEmptyDocument">
    <ng-container *ngIf="!!hasCustomMaskError; else customInvalidDocumentValueErrorTemplate">
      <ng-container *ngTemplateOutlet="customPatternErrorTemplate; context: { customError: customMaskError } "></ng-container>
    </ng-container>
    <ng-template #customInvalidDocumentValueErrorTemplate>
      <ng-container *ngTemplateOutlet="customPatternErrorTemplate; context: { customError: customInvalidDocumentValueError } "></ng-container>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #generalNotEmptyDocument>
  <span class="only-error" [ngClass]="addErrorClass(formControlSelector)">
    {{ 'BOOKING_MODULE.PAX.ERRORS.PAX_DOCUMENT_NOT_EMPTY_GENERAL_ERROR' | transloco }}
  </span>
</ng-template>

<ng-template #customPatternErrorTemplate let-customError='customError'>
  <span class="only-error" [ngClass]="addErrorClass(formControlSelector)">
    {{ customError?.VALUE }}
  </span>
</ng-template>

<ng-template #internationalMandatoryError>
  <span class="only-error" [ngClass]="addErrorClass(formControlSelector)">
    {{ 'BOOKING_MODULE.PAX.ERRORS.MANDATORY_INTERNATIONAL_DOCUMENT' | transloco }}
  </span>
</ng-template>

<ng-template #errorGeneral>
  <span class="only-error" [ngClass]="addErrorClass(formControlSelector)">
    {{'BOOKING_MODULE.PAX.ERRORS.MANDATORY_FIELD' | transloco}}
  </span>
</ng-template>

<ng-template #textInputs>
  <ng-container [ngSwitch]="formInputType">
    <ng-container *ngSwitchCase="formInputTypes.FULL_TEXT">
      <ng-container *ngTemplateOutlet="fullText"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formInputTypes.ONLY_LETTERS">
      <ng-container *ngTemplateOutlet="onlyLetters"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formInputTypes.ONLY_NUMBERS">
      <ng-container *ngTemplateOutlet="onlyDigits"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formInputTypes.EMAIL">
      <ng-container *ngTemplateOutlet="emailInput"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formInputTypes.CUSTOM_MASK">
      <ng-container *ngTemplateOutlet="customMaskInput"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #documentInputs>
  <ng-container [ngSwitch]="inputDocumentType">
    <ng-container *ngSwitchCase="formDocumentInputTemplates.ALPHANUMERIC">
      <ng-container *ngTemplateOutlet="alphanumeric"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formDocumentInputTemplates.CNPJ">
      <ng-container *ngTemplateOutlet="cnpjDigits"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formDocumentInputTemplates.CPF">
      <ng-container *ngTemplateOutlet="cpfDigits"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formDocumentInputTemplates.CUIL">
      <ng-container *ngTemplateOutlet="cuilDigits"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formDocumentInputTemplates.CUIT">
      <ng-container *ngTemplateOutlet="cuitDigits"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formDocumentInputTemplates.DIGITS">
      <ng-container *ngTemplateOutlet="onlyDigitsByMask"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formDocumentInputTemplates.NIT">
      <ng-container *ngTemplateOutlet="nitDigits"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="formDocumentInputTemplates.RUC_PE">
      <ng-container *ngTemplateOutlet="rucDigits"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #onlyDigits>
  <ng-container [formGroup]="form">
    <input appOnlyDigits
      type="text"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholder"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [id]="id" autocomplete="off"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #fullText>
  <ng-container [formGroup]="form">
    <input
      type="text"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [id]="id" autocomplete="off"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #onlyLetters>
  <ng-container [formGroup]="form">
    <input
      type="text"
      autocomplete="off"
      class="uppercase"
      [id]="id"
      [mask]="'S*'"
      [patterns]="onlyLettersPatterns"
      [dropSpecialCharacters]="false"
      [specialCharacters]="[' ']"
      [clearIfNotMatch]="false"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="outputTransformFn()"
      (click)="clickEvent($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)">
  </ng-container>
</ng-template>

<ng-template #emailInput>
  <ng-container [formGroup]="form">
    <input
      type="email"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [id]="id" autocomplete="off"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #customMaskInput>
  <ng-container [formGroup]="form">
    <input
      [attr.type]="customAttrType"
      autocomplete="off"
      [id]="id"
      [mask]="customMask"
      [dropSpecialCharacters]="false"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)"
      (click)="clickEvent($event)">
  </ng-container>
</ng-template>

<ng-template #alphanumeric>
  <ng-container [formGroup]="form">
    <input
      type="text"
      autocomplete="off"
      [mask]="inputMask.ALPHANUMERIC"
      [dropSpecialCharacters]="true"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [id]="id"
      [attr.pattern]="inputRegex.ALPHANUMERIC"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #onlyDigitsByMask>
  <ng-container [formGroup]="form">
    <input
      type="tel"
      autocomplete="off"
      [mask]="inputMask.DIGITS"
      [dropSpecialCharacters]="true"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [id]="id"
      [attr.pattern]="inputRegex.NUMERIC"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #nitDigits>
  <ng-container [formGroup]="form">
    <input
      type="text"
      autocomplete="off"
      [mask]="inputMask.NIT"
      [dropSpecialCharacters]="false"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [id]="id"
      [attr.pattern]="inputRegex.NIT"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #cpfDigits>
  <ng-container [formGroup]="form">
    <input
      type="text"
      autocomplete="off"
      [id]="id" 
      [mask]="inputMask.CPF"
      [dropSpecialCharacters]="false"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [attr.pattern]="inputRegex.CPF"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #cnpjDigits>
  <ng-container [formGroup]="form">
    <input
      type="text"
      autocomplete="off"
      [id]="id"
      [mask]="inputMask.CNPJ"
      [dropSpecialCharacters]="false"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [attr.pattern]="inputRegex.CNPJ"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #cuilDigits>
  <ng-container [formGroup]="form">
    <input 
      type="text"
      autocomplete="off"
      [id]="id"
      [mask]="inputMask.CUIL"
      [dropSpecialCharacters]="false"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [attr.pattern]="inputRegex.CUIL"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #cuitDigits>
  <ng-container [formGroup]="form">
    <input 
      type="text"
      autocomplete="off"
      [id]="id"
      [mask]="inputMask.CUIT"
      [dropSpecialCharacters]="false"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [attr.pattern]="inputRegex.CUIT"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>

<ng-template #rucDigits>
  <ng-container [formGroup]="form">
    <input 
      type="text"
      autocomplete="off"
      [id]="id"
      [mask]="inputMask.RUC_PE"
      [dropSpecialCharacters]="false"
      [class.not-placeholder]="isEmptyPlaceholder"
      [placeholder]="placeholderText"
      [readonly]="readOnly"
      (click)="clickEvent($event)"
      [attr.pattern]="inputRegex.RUC_PE"
      [formControlName]="formControlSelector"
      [attr.maxlength]="maxLength"
      (ngModelChange)="changeValue($event)"
      (focus)="setActive(true)"
      (blur)="setActive(false)"
      (keyup)="selectionInput($event)">
  </ng-container>
</ng-template>
